export default __webpack_public_path__ + "static/media/a037-9.5572105a.svg";